import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

export default function SingleRoom() {
    
  return (
    <>
    
    {/* slider  */}
    <div className="container single-page-room-main-container">
        <div className="single-room-h1">
            <h1 >Classic Room</h1>
            <div ></div>
        </div>

        {/* slider */}
           <div id="carouselExampleAutoplaying" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src="/images/classicroom1.JPG" loading="lazy" className="d-block w-100" alt="classic room"/>
    </div>
    <div className="carousel-item">
      <img src="/images/classicroom1.JPG" loading="lazy" className="d-block w-100" alt="classic room"/>
    </div>
    <div className="carousel-item">
      <img src="/images/classicroom1.JPG" loading="lazy" className="d-block w-100" alt="classic room"/>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
           </div>

           <div className="simple-room-para">
            <p>Our 21 Executive Rooms provide a cosy and inviting space of 216 sq. ft., ideal for both business and leisure travellers. With king or twin beds, these rooms comfortably host up to three guests and include amenities such as a 32-inch television, complimentary bottled water, tea & coffee-making facilities, and complimentary Wi-Fi. Perfect for a short stay near Delhi, the room also includes 24-hour hot water and a wardrobe, ensuring comfort and convenience for a relaxing experience convenience for a relaxing experience convenience for a relaxing experience.</p>
           </div>

           <div className="simple-room-button">
           <Link  title='v hotel the grand shoba Room Page' to="/check-availability"><button className='book-now-btn'>BOOK NOW</button> </Link> 
           </div>

           {/* Amenities section */}
           <div className="simple-room-amenities">
              <span className=''>Amenities</span>
              <div className="row">
                <div className="col-md-6">
                    <div className="simple-room-service d-flex">
                        <div className="simple-room-service-icon">
                            <img src="/images/ac.svg" loading="lazy" width='50' height={50} alt="AC" />
                        </div>
                        <div className="simple-room-service-name">
                        <h5>Air-Conditioning (AC)</h5>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="simple-room-service d-flex">
                        <div className="simple-room-service-icon">
                            <img src="/images/wifi.svg" width='50' loading="lazy" height={50} alt="WIFI" />
                        </div>
                        <div className="simple-room-service-name">
                        <h5>Complimentary Wi-Fi</h5>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="simple-room-service d-flex">
                        <div className="simple-room-service-icon">
                            <img src="/images/bed.svg" width='50' loading="lazy" height={50} alt="Bed" />
                        </div>
                        <div className="simple-room-service-name">
                        <h5>King/Twin Bed</h5>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="simple-room-service d-flex">
                        <div className="simple-room-service-icon">
                            <img src="/images/tv.svg" width='50' loading="lazy" height={50} alt="TV" />
                        </div>
                        <div className="simple-room-service-name">
                        <h5>Television (32-inch)</h5>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="simple-room-service d-flex">
                        <div className="simple-room-service-icon">
                            <img src="/images/tea.svg" width='50' loading="lazy" height={50} alt="Tea" />
                        </div>
                        <div className="simple-room-service-name">
                        <h5>Tea & Coffee Maker</h5>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="simple-room-service d-flex">
                        <div className="simple-room-service-icon">
                            <img src="/images/bar.svg" width='50' loading="lazy" height={50} alt="MiniBar" />
                        </div>
                        <div className="simple-room-service-name">
                        <h5>Minibar</h5>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="simple-room-service d-flex">
                        <div className="simple-room-service-icon">
                            <img src="/images/wardor.svg" width='50' loading="lazy" height={50} alt="Wardrobe" />
                        </div>
                        <div className="simple-room-service-name">
                        <h5>Wardrobe</h5>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="simple-room-service d-flex">
                        <div className="simple-room-service-icon">
                            <img src="/images/ser.svg" width='50' loading="lazy" height={50} alt="Service" />
                        </div>
                        <div className="simple-room-service-name">
                        <h5>Express 4-hour Laundry Service (chargeable)</h5>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="simple-room-service d-flex">
                        <div className="simple-room-service-icon">
                            <img src="/images/bath.svg" width='50' loading="lazy" height={50} alt="Service" />
                        </div>
                        <div className="simple-room-service-name">
                        <h5>Bathtub</h5>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="simple-room-service d-flex">
                        <div className="simple-room-service-icon">
                            <img src="/images/hotwater.svg" width='50' loading="lazy" height={50} alt="Service" />
                        </div>
                        <div className="simple-room-service-name">
                        <h5>Hot Water Showers (24/7)</h5>
                        </div>
                    </div>
                </div>

              </div>
           </div>
    </div>

    </>
  )
}
